import { listPropertyUrl, deleteFileUrl , deleteProppertyUrl, updateOrderProppertyUrl, propertyLocationOptionsUrl, updateListingUrl} from '../api/index'
import axios from 'axios'
import { notification } from 'antd'
import { getToken } from '../../../request'
import { addListingUrl, deleteListingUrl } from '../api'


export const addListingAction = async params => {
  try {
    let { data } = await axios.post(
      addListingUrl(),
      { ...params },
      getToken()
    )
    return data
  } catch (err) {
    notification.error({
      message: 'Error'
    })
    return null
  }
}
export const updateListingAction = async params => {
  try {
    let { data } = await axios.put(
      updateListingUrl(),
      { ...params },
      getToken()
    )

    return data
  } catch (err) {
    notification.error({
      message: 'Error'
    })
    return null
  }
}

export const listListingAction = async params => {
  try {
    let { data } = await axios.get(
      listPropertyUrl(), { params: { ...params }, ...getToken() })
    if (data.error) {
      notification.error({
        message: data.message
      })
    }
    return data
  } catch (err) {
    notification.error({
      message: 'Error'
    })
    return null
  }
}

export const deleteFileAction = async params => {
  try {
    let { data } = await axios.post(
      deleteFileUrl(),
      { ...params },
      getToken()
    )
    return data
  } catch (err) {
    notification.error({
      message: 'Error'
    })
    return null
  }
}

export const deleteListingAction = async params => {
  try {
    let { data } = await axios.delete(
      deleteListingUrl(params.id), { ...getToken() })
    if (data.error) {
      notification.error({
        message: data.message
      })
    }
    return data
  } catch (err) {
    notification.error({
      message: 'Error'
    })
    return null
  }
}

export const updatePropertyOrderAction = async params => {
  try {
    let { data } = await axios.put(
      updateOrderProppertyUrl(),
      { ...params },
      getToken()
    )

    return data
  } catch (err) {
    notification.error({
      message: 'Error'
    })
    return null
  }
}


export const propertyLocationOptionsAction = async () => {
  try {
    let { data } = await axios.get(
      propertyLocationOptionsUrl(),
      getToken()
    )

    return data
  } catch (err) {
    notification.error({
      message: 'Error'
    })
    return null
  }
}





